import { render, staticRenderFns } from "./CreateMainboard.vue?vue&type=template&id=0d106018&"
import script from "./CreateMainboard.vue?vue&type=script&lang=js&"
export * from "./CreateMainboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports